export default "__VITE_ASSET__BWirTQUv__"